import { createAction, union } from '@ngrx/store';
import { ImportExportDialogModes } from './import-export-dialog.model';

export const importExportDialogOpen = createAction(
  '[@zerops/zerops/feature/import-export-dialog] open',
  (data: { entity?: 'project' | 'service-stack';  mode?: ImportExportDialogModes; yaml?: string; projectId?: string; exportId?: string; reveal?: boolean; canRevealSecrets?: boolean; recipeSource?: string; recipeSourceUrl?: string }) => (
    {
      entity: data.entity ? data.entity : 'project',
      mode: data.mode,
      yaml: data.yaml,
      projectId: data.projectId,
      exportId: data.exportId,
      reveal: data.reveal,
      // whether this viewer may export decrypted secrets, resolved by whoever
      // triggered the export - the dialog only reads it
      canRevealSecrets: data.canRevealSecrets,
      recipeSource: data.recipeSource,
      recipeSourceUrl: data.recipeSourceUrl
    }
  )
);

const all = union({ importExportDialogOpen });

export type ImportExportDialogActionUnion = typeof all;
